/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserStreakResponse } from './UserStreakResponse';
import {
    UserStreakResponseFromJSON,
    UserStreakResponseFromJSONTyped,
    UserStreakResponseToJSON,
    UserStreakResponseToJSONTyped,
} from './UserStreakResponse';
import type { StreakConfigResponse } from './StreakConfigResponse';
import {
    StreakConfigResponseFromJSON,
    StreakConfigResponseFromJSONTyped,
    StreakConfigResponseToJSON,
    StreakConfigResponseToJSONTyped,
} from './StreakConfigResponse';

/**
 * 
 * @export
 * @interface MyStreakEntry
 */
export interface MyStreakEntry {
    /**
     * 
     * @type {UserStreakResponse}
     * @memberof MyStreakEntry
     */
    streak?: UserStreakResponse;
    /**
     * 
     * @type {StreakConfigResponse}
     * @memberof MyStreakEntry
     */
    config?: StreakConfigResponse;
}

/**
 * Check if a given object implements the MyStreakEntry interface.
 */
export function instanceOfMyStreakEntry(value: object): value is MyStreakEntry {
    return true;
}

export function MyStreakEntryFromJSON(json: any): MyStreakEntry {
    return MyStreakEntryFromJSONTyped(json, false);
}

export function MyStreakEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): MyStreakEntry {
    if (json == null) {
        return json;
    }
    return {
        
        'streak': json['streak'] == null ? undefined : UserStreakResponseFromJSON(json['streak']),
        'config': json['config'] == null ? undefined : StreakConfigResponseFromJSON(json['config']),
    };
}

export function MyStreakEntryToJSON(json: any): MyStreakEntry {
    return MyStreakEntryToJSONTyped(json, false);
}

export function MyStreakEntryToJSONTyped(value?: MyStreakEntry | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'streak': UserStreakResponseToJSON(value['streak']),
        'config': StreakConfigResponseToJSON(value['config']),
    };
}

